App.controller('HealthStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$timeout', '$mdDialog', 'Config', function ($scope, $sce, $state, $http, packageService, $timeout, $mdDialog, Config) {
    $scope.page = 'health_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Opieka medyczna - poprzedni program';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $timeout(function() {
    	if (!$('.menu.menu_3').hasClass('open')) {
    		$('a[target=".menu_3"]').trigger('click');
    	}
    }, 0);

    packageService.dataPackageLists().then(function (data) {
        $scope.package = data.data.group;
    });

    $scope.fillDeclaration = function() {
        var dateNow = moment().toDate();
        var dateTo = moment('2019-10-21').toDate();
        dateTo.setHours(0, 0, 0, 0);

        if (dateTo.getTime() <= dateNow.getTime()) {
            $scope.showInformationPopUp(
                '',
                '',
                'Możliwość przystąpień do programu abonamentów zdrowotnych w POLMED została wyłączona. Od 1 grudnia 2019 r. rusza nowy program ubezpieczenia zdrowotnego w TU ZDROWIE. Aby wypełnić deklarację przystąpienia, należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'true',
                'Rozumiem',
                '');
            return;
        }

        var url = $scope.__logged ? 'root.home.insurance.list' : 'root.login';
        $state.go(url);
    };

    function initInformationPopUp() {
        var dateNow = moment().toDate();
        var dateTo = moment('2019-10-20').toDate();
        dateTo.setHours(23, 59, 59, 999);

        if (dateNow.getTime() <= dateTo.getTime()) {
            $scope.showInformationPopUp(
                '',
                '',
                'Od 1 grudnia 2019 r. obowiązywać będzie nowy program ubezpieczenia zdrowotnego dla pracowników i członków ich rodzin. Aby przystąpić do nowego programu należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'true',
                'Rozumiem',
                '');
            return;
        }

        dateTo = moment('2019-10-21').toDate();
        dateTo.setHours(0, 0, 0, 0);

        if (dateTo.getTime() <= dateNow.getTime()) {
            $scope.showInformationPopUp(
                '',
                '',
                'Możliwość przystąpień do programu abonamentów zdrowotnych w POLMED została wyłączona. Od 1 grudnia 2019 r. rusza nowy program ubezpieczenia zdrowotnego w TU ZDROWIE. Aby wypełnić deklarację przystąpienia, należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'true',
                'Rozumiem',
                '');
        }

    }

    $scope.showInformationPopUp = function(ev, head, content, text, target, exit, secondButtonText, secondButtonTarget) {
        $mdDialog.show({
            controller: informationPopUpCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                },
                secondButton: {
                    text: secondButtonText,
                    target: secondButtonTarget
                }
            }
        }).then(function(data) {

        }, function() {

        })
    };

    function informationPopUpCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    initInformationPopUp();

}]);
